import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'

const IdleTimeoutDialog = ({ open, onClose, onLogout, item}) => {

    const showOpenLimitTimeRef = React.useRef(open);
    const [title, setTitle] = React.useState('');
    const [btn, setBtn] = React.useState('');
    const [countdown, setCountdown] = React.useState(1000);
    const [texts, setTexts] = useState([]);

    const sessionTimerRef = React.useRef(null);

    const handleClose = () =>{
        if(typeof onClose === 'function')
        {
            if (sessionTimerRef.current) {
                clearInterval(sessionTimerRef.current);
                sessionTimerRef.current = null;
            }

            onClose()
        }
    }

    React.useEffect(() => {
        if(countdown === 0 && typeof onLogout === 'function')
        {
            if (sessionTimerRef.current) {
                clearInterval(sessionTimerRef.current);
                sessionTimerRef.current = null;
            }

            onLogout()
        }
    }, [countdown, onLogout]);

    const handleCountdown = () => {

        sessionTimerRef.current = setInterval(() => {
            if (showOpenLimitTimeRef.current === true) {
                setCountdown((prevCountdown) =>
                prevCountdown > 0 ? prevCountdown - 1 : prevCountdown
                );
            }
            }, 1000);

        return () => clearInterval(sessionTimerRef.current);
    };

    React.useEffect(() => {
        showOpenLimitTimeRef.current = open;

        if(open && item)
        {
            setTexts(item.texts)
            setCountdown(item.countdown)
            setTitle(item.title)
            setBtn(item.btn)
        }

        return handleCountdown()
    }, [open, item]);

    return <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
    >
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <ErrorOutlineOutlinedIcon color="action" style={{ fontSize: 48 }}></ErrorOutlineOutlinedIcon>
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" variant="h3">{title}</Typography>
                </Grid>

                {
                    texts.map((txt, i) => {
                        if (txt.indexOf('{minute}') > -1 && txt.indexOf('{secound}') > -1) {
                            const txtMinutes = txt.split('{minute}')

                            const txtSecounds = txtMinutes[1].split('{secound}')

                            return <Grid item xs={12} key={'idle-line'+i}>
                                <Typography align="center" variant="h5">{txtMinutes[0]} {Math.floor(countdown / 60)} {txtSecounds[0]} {countdown % 60} {txtSecounds[1]}</Typography>
                            </Grid>
                        }
                        else if (txt.indexOf('{minute}') > -1) {
                            const txtMinutes = txt.split('{minute}')

                            return <Grid item xs={12} key={'idle-line'+i}>
                                <Typography align="center" variant="h5">{txtMinutes[0]} {Math.floor(countdown / 60)} {txtMinutes[1]}</Typography>
                            </Grid>
                        }
                        else if (txt.indexOf('{secound}') > -1) {
                            const txtSecounds = txt.split('{secound}')

                            return <Grid item xs={12} key={'idle-line'+i}>
                                <Typography align="center" variant="h5">{txtSecounds[0]} {countdown} {txtSecounds[1]}</Typography>
                            </Grid>
                        }
                        else {
                            return <Grid item xs={12} key={'idle-line'+i}>
                                <Typography align="center" variant="h5">{txt}</Typography>
                            </Grid>
                        }
                    }

                    )
                }
            </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", paddingBottom: 25, paddingTop: 15 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={handleClose}
              >
                &nbsp;&nbsp;{btn}&nbsp;&nbsp;
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
    </Dialog>
}

export default IdleTimeoutDialog;